import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useBillingApi from "./api/useBillingApi";

const ALLOWED_PATHS = new Set([
  "/dashboard/billing/plans",
]);

const useSubscription = () => {
  const [plans, setPlans] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { fetchPlans } = useBillingApi();

  useEffect(() => {
    const loadPlans = async () => {
      try {
        const response = await fetchPlans();
        const data = response.data;
        setPlans(data?.plans);

        if (
          data &&
          data.isSubscribed === false &&
          !ALLOWED_PATHS.has(location.pathname) &&
          !location.pathname.startsWith("/dashboard/billing/plans/checkout")
        ) {
          if (data.plans && data.plans[0]?.plan_id) {
            navigate("/dashboard/billing/plans");
          }
        }
      } catch (error) {
        console.error("Error to get plans:", error);
      }
    };

    loadPlans();
  }, [fetchPlans, navigate, location.pathname]);

  return plans;
};

export default useSubscription;

